export default class BusinessQuiz {
  public cnpj: string | undefined;
  public razaoSocial: string | undefined;
  public cnae: string | undefined;
  public companyType: string | undefined;
  public lastThreeMonthsRevenue: number | undefined;
  public cardsRevenue: number | undefined;
  public currentAcquirer: string | undefined;
  public hasSpecialCheck: boolean | undefined;
  public hasGuaranteedAccount: boolean | undefined;
  public hasOtherLoans: boolean | undefined;
  public hasDebt: boolean | undefined;
  public debtValue: number | undefined;
  public debitRate: number | undefined;
  public debitRateAtSight: number | undefined;
  public creditRateAtSight: number | undefined;
  public creditRateInstallments: number | undefined;
  public creditRateInstallmentsTwo: number | undefined;
  public specialCheckValue: number | undefined;
  public guaranteedAccountValue: number | undefined;
  public otherLoansValue: number | undefined;

  constructor(
    cnpj: string | undefined = undefined,
    companyType: string | undefined = undefined,
    lastThreeMonthsRevenue: number | undefined = undefined,
    cardsRevenue: number | undefined = undefined,
    currentAcquirer: string | undefined = undefined,
    hasSpecialCheck: boolean | undefined = undefined,
    hasGuaranteedAccount: boolean | undefined = undefined,
    hasOtherLoans: boolean | undefined = undefined,
    hasDebt: boolean | undefined = undefined,
    debtValue: number | undefined = undefined,
    debitRate: number | undefined = undefined,
    debitRateAtSight: number | undefined = undefined,
    creditRateAtSight: number | undefined = undefined,
    creditRateInstallments: number | undefined = undefined,
    creditRateInstallmentsTwo: number | undefined = undefined,
    specialCheckValue: number | undefined = undefined,
    guaranteedAccountValue: number | undefined = undefined,
    otherLoansValue: number | undefined = undefined,
    razaoSocial: string | undefined = undefined,
    cnae: string | undefined = undefined
  ) {
    this.cnpj = cnpj;
    this.companyType = companyType;
    this.lastThreeMonthsRevenue = lastThreeMonthsRevenue;
    this.cardsRevenue = cardsRevenue;
    this.currentAcquirer = currentAcquirer;
    this.hasSpecialCheck = hasSpecialCheck;
    this.hasGuaranteedAccount = hasGuaranteedAccount;
    this.hasOtherLoans = hasOtherLoans;
    this.hasDebt = hasDebt;
    this.debtValue = debtValue;
    this.debitRate = debitRate;
    this.debitRateAtSight = debitRateAtSight;
    this.creditRateAtSight = creditRateAtSight;
    this.creditRateInstallments = creditRateInstallments;
    this.creditRateInstallmentsTwo = creditRateInstallmentsTwo;
    this.specialCheckValue = specialCheckValue;
    this.guaranteedAccountValue = guaranteedAccountValue;
    this.otherLoansValue = otherLoansValue;
    this.razaoSocial = razaoSocial;
    this.cnae = cnae;
  }
}
